module.exports = ".container {\r\n\twidth:100%;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.css
// module id = ./src/app/home/home.component.css
// module chunks = main